export const GET_INSTANCES_REQUEST = "GET_INSTANCES_REQUEST";
export const GET_INSTANCES_SUCCESS = "GET_INSTANCES_SUCCESS";
export const GET_INSTANCES_FAILURE = "GET_INSTANCES_FAILURE";
export const RESET_INSTANCES_IS_FETCHED = "RESET_INSTANCES_IS_FETCHED";
export const RESET_INSTANCE_LIST = "RESET_INSTANCE_LIST";
